export const INIT_ERROR_PAYMENT = "INIT_ERROR_PAYMENT";
export const ERROR_PAYMENT = "ERROR_PAYMENT";
